import { tryLoadLightDOMStyles } from '../Global/loadDependency'
import { getTemplateTemplateScaffoldStyles } from './NavHeader-UserDetails.styles'

const t = document.createElement('template')
t.innerHTML = `
<div class="user-details-column-item-wrapper">
  <div class="user-details-column-item">

    <ts-userdetails>
      <span slot="username" id="username"></span>

      <ts-organization-info variant="utility-menu">
        <span slot="organizationName" id="organizationName"></span>
        <span slot="contractNumber" id="contractNumber"></span>
      </ts-organization-info>

    </ts-userdetails>

  </div>
</div>
`
const TemplateNavHeaderUserDetails = t

class NavHeaderUserDetails extends HTMLElement {
  private usernameEl!: HTMLElement
  private orgEl!: HTMLElement
  private contractEl!: HTMLElement

  constructor() {
    super()

    const shadow = this.attachShadow({ mode: 'open' })
    shadow.appendChild(getTemplateTemplateScaffoldStyles().content.cloneNode(true))
    shadow.appendChild(TemplateNavHeaderUserDetails.content.cloneNode(true))

    tryLoadLightDOMStyles('NavHeader-UserDetails.css')

    this.usernameEl = shadow.querySelector('#username')!
    this.orgEl = shadow.querySelector('#organizationName')!
    this.contractEl = shadow.querySelector('#contractNumber')!
  }

  connectedCallback() {
    document.AscendAwesome?.LogManager?.logDebug('NavHeaderUserDetails connectedCallback')
    this.updateValues()
  }

  static get observedAttributes() {
    return ['username', 'organizationName', 'contractNumber']
  }
  attributeChangedCallback() {
    this.updateValues()
  }

  private updateValues() {
    if (this.usernameEl) this.usernameEl.textContent = this.getAttribute('username') || ''

    if (this.orgEl) this.orgEl.textContent = this.getAttribute('organizationName') || ''

    if (this.contractEl) this.contractEl.textContent = this.getAttribute('contractNumber') || ''
  }
}

if (!customElements.get('ts-navheader-userdetails')) {
  customElements.define('ts-navheader-userdetails', NavHeaderUserDetails)
}
export { NavHeaderUserDetails }
